// extracted by mini-css-extract-plugin
module.exports = {"root":"ResetPasswordForm_root__rwtOG","form":"ResetPasswordForm_form__3NqFk","button":"ResetPasswordForm_button__3r86R"};